import * as CryptoJS from 'crypto-js';

export function getKeyBytes(key) {
    return CryptoJS.enc.Utf8.parse(key);
}

export function getIvBytes(iv) {
    return CryptoJS.enc.Utf8.parse(iv);
}

export function aesEncrypt(str) {
    const keyBytes = getKeyBytes(process.env.REACT_APP_AES_ENCRYPT_KEY);
    const encrypted = CryptoJS.AES.encrypt(str, keyBytes, {
        iv: keyBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();

    return encrypted;
}

export function aesDecrypt(encryptedStr) {
    const keyBytes = getKeyBytes(process.env.REACT_APP_AES_ENCRYPT_KEY);
    const decrypted = CryptoJS.AES.decrypt(encryptedStr, keyBytes, {
        iv: keyBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);

    return decrypted;
}

